<template>
    <canvas ref="canvas"></canvas>
</template>

<script>
import Chart from 'chart.js/auto'
import { calculateTotalWeight, createWeightBins } from '@/utils/tasks/chopping-utils.js'

export default {
  name: 'WeightDistributionChart',
  props: {
    tasks: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.createChart()
  },
  watch: {
    tasks: {
      handler() {
        this.updateChart()
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy()
    }
  },
  methods: {
    createChart() {
      const ctx = this.$refs.canvas.getContext('2d')
      
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.getBinLabels(),
          datasets: [{
            label: 'Number of Tasks',
            data: this.getDistributionData(),
            backgroundColor: 'rgba(156, 39, 176, 0.6)',
            borderColor: 'rgba(156, 39, 176, 1)',
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            title: {
              display: true,
              text: 'Weight Distribution (kg)'
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  return `${context.parsed.y} tasks`
                }
              }
            }
          },
          scales: {
            x: {
              title: {
                display: true,
                text: 'Weight Range (kg)'
              }
            },
            y: {
              title: {
                display: true,
                text: 'Number of Tasks'
              },
              beginAtZero: true,
              ticks: {
                stepSize: 1
              }
            }
          }
        }
      })
    },
    
    updateChart() {
      if (this.chart) {
        this.chart.data.labels = this.getBinLabels()
        this.chart.data.datasets[0].data = this.getDistributionData()
        this.chart.update()
      }
    },
    
    getDistributionData() {
      const weights = this.tasks.map(task => calculateTotalWeight(task.description) / 1000) // Convert to kg
      const bins = createWeightBins(weights)
      return bins.map(bin => bin.count)
    },
    
    getBinLabels() {
      const weights = this.tasks.map(task => calculateTotalWeight(task.description) / 1000) // Convert to kg
      const bins = createWeightBins(weights)
      return bins.map(bin => `${bin.min.toFixed(1)}-${bin.max.toFixed(1)}`)
    }
  }
}
</script>

<style scoped>
</style>